/**
 * This script handles the functionality of sharing a job via email.
 * It is triggered when the user clicks on the 'share-submit' button.
 *
 * @file job-share.js
 */

// When the 'share-submit' button is clicked
jQuery('#share-submit').click(e => {
    // Prevent the default action of the button
    e.preventDefault();

    // Get the button that was clicked and its parent form
    let button = jQuery(this);
    let modal = button.parents('form');

    // Remove any existing alerts
    jQuery('.alert').removeClass('alert');

    // If the 'ohnoho' input field is empty, stop the function
    if(jQuery('.ohnoho').val().length != 0) {
        return false;
    }

    // Make an AJAX POST request to the '/ajax/emailshare' endpoint
    jQuery.ajax({
        url: '/ajax/emailshare',
        type: 'POST',
        // Serialize the form data and append the current URL
        data: modal.serialize() + "&url=" + window.location.href,
        dataType: 'json',
        // On success, handle the response data
        success: data => {
            // If there are errors, display them
            if(data.errors.length > 0) {
                let errors_html = data.errors.map(error => error['message'] + '<br />').join('');
                data.errors.forEach(error => jQuery('#' + error['error']).addClass('alert'));
                jQuery('.errors').html(errors_html);
            } else {
                // If there are no errors, display a success message
                jQuery('.container-modal-form').addClass('container-form').html('<div class="ct-icon"><div class="icon icon-folder-white"></div></div><h2 class="h2-title-green">Félicitations</h2><p>L’annonce a correctement été envoyée</p>');
            }
        },
        // On error, log the error details to the console
        error: (xhr, ajaxOptions, thrownError) => {
            console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
    });
});
